export default {
  name: "Regional",
  regions: [
    {
      name: "Regional/CanaryIslands",
      alias: "Canary Islands",
      center: {
        lon: -16,
        lat: 27.853,
        zoom: 8
      },
      sectors: [
        {
          name: "Aquaculture",
          alias: "Aquaculture",
          types: [
            {
              alias: "Biological Suitability",
              name: "BiologicalSuitability",
              ico: "biological",
              provider: "Thredds_MSP",
              layers: [
                {
                  description: "Atlantic Bluefin Tuna",
                  name: "bluefin_tuna",
                  alias: "Thunnus thynnus",
                  visible: false
                },
                {
                  description: "Atlantic Wreckfish",
                  name: "wreckfish",
                  alias: "Polyprion americanus",
                  visible: false
                },
                {
                  description: "Meagre",
                  name: "meagre",
                  alias: "Argyrosomus regius",
                  visible: false
                },
                {
                  description: "Gilthead Seabream",
                  name: "gilthead",
                  alias: "Sparus aurata",
                  visible: false
                },
                {
                  description: "European Seabass",
                  name: "seabass",
                  alias: "Dicentrarchus labrax",
                  visible: false
                },
                {
                  description: "Dusky Grouper",
                  name: "dusky",
                  alias: "Epinephelus marginatus",
                  visible: false
                },
                {
                  description: "Red Porgy",
                  name: "porgy",
                  alias: "Pagrus pagrus",
                  visible: false
                },
                {
                  description: "Greater Amberjack",
                  name: "amberjack",
                  alias: "Seriola dumerilii",
                  visible: false
                }
              ]
            },
            {
              alias: "Structural Suitability",
              name: "StructuralSuitability",
              provider: "Thredds_MSP",
              ico: "structural",
              layers: [
                {
                  alias: "Structural Suit. Index",
                  name: "structural",
                  visible: false
                }
              ]
            },
            {
              alias: "Operational Suitability",
              name: "OperationalSuitability",
              ico: "operational",
              provider: "Thredds_MSP",
              layers: [
                {
                  alias: "Operational Suit. Index",
                  name: "operational",
                  visible: false
                }
              ]
            },
            {
              alias: "Farming Opportunities",
              name: "FishFarmingOpportunities",
              ico: "opportunity",
              provider: "Thredds_MSP",
              layers: [
                {
                  description: "Atlantic Bluefin Tuna",
                  name: "bluefin_tuna",
                  alias: "Thunnus thynnus",
                  visible: false
                },
                {
                  description: "Atlantic Wreckfish",
                  name: "wreckfish",
                  alias: "Polyprion americanus",
                  visible: false
                },
                {
                  description: "Meagre",
                  name: "meagre",
                  alias: "Argyrosomus regius",
                  visible: false
                },
                {
                  description: "Gilthead Seabream",
                  name: "gilthead",
                  alias: "Sparus aurata",
                  visible: false
                },
                {
                  description: "European Seabass",
                  name: "seabass",
                  alias: "Dicentrarchus labrax",
                  visible: false
                },
                {
                  description: "Dusky Grouper",
                  name: "dusky",
                  alias: "Epinephelus marginatus",
                  visible: false
                },
                {
                  description: "Red Porgy",
                  name: "porgy",
                  alias: "Pagrus pagrus",
                  visible: false
                },
                {
                  description: "Greater Amberjack",
                  name: "amberjack",
                  alias: "Seriola dumerilii",
                  visible: false
                }
              ]
            }
          ]
        },
        {
          name: "Energy",
          alias: "Marine Energy",
          types: [
            {
              alias: "Energy Resource Suit.",
              name: "EnergyResourceSuitability",
              ico: "energy",
              provider: "Thredds_MSP",
              layers: [
                {
                  alias: "Wind Resource",
                  name: "Wind_Resource",
                  visible: false
                },
                {
                  alias: "Wave Resource",
                  name: "Wave_Resource",
                  visible: false
                }
              ]
            },
            {
              alias: "Structural Suitability",
              name: "StructuralSuitability",
              ico: "structural",
              provider: "Thredds_MSP",
              layers: [
                {
                  alias: "Survivability (Wave & Wind Devices)",
                  name: "Structural_Survivability",
                  visible: false
                }
              ]
            },
            {
              alias: "Operational Suitability",
              name: "OperationalSuitability",
              ico: "operational",
              provider: "Thredds_MSP",
              layers: [
                {
                  alias: "Logistics",
                  name: "Operational",
                  visible: false
                }
              ]
            },
            {
              alias: "Energy Transport",
              name: "EnergyTransport",
              ico: "operational",
              provider: "Thredds_MSP",
              layers: [
                {
                  alias: "Energy Transport",
                  name: "Energy_Transport",
                  visible: false
                }
              ]
            },
            {
              alias: "Renewable Energy Opportunities",
              name: "RenewableEnergyOpportunities",
              ico: "opportunity",
              provider: "Thredds_MSP",
              layers: [
                {
                  alias: "Wind Energy",
                  name: "Wind_Energy",
                  visible: false
                },
                {
                  alias: "Wave Energy",
                  name: "Wave_Energy",
                  visible: false
                }
              ]
            }
          ]
        }
      ]
    },
    {
      name: "Regional/Balearics",
      alias: "Balearic Islands",
      center: {
        lon: 3.5,
        lat: 39.5,
        zoom: 9
      },
      sectors: [
        {
          name: "Aquaculture",
          alias: "Aquaculture",
          types: [
            {
              alias: "Biological Suitability",
              name: "BiologicalSuitability",
              ico: "biological",
              provider: "Thredds_MSP",
              layers: [
                {
                  description: "Atlantic Bluefin Tuna",
                  name: "bluefin_tuna",
                  alias: "Thunnus thynnus",
                  visible: false
                },
                {
                  description: "Atlantic Cod",
                  name: "cod",
                  alias: "Gadus morhua",
                  visible: false
                },
                {
                  description: "Blackspot Seabram",
                  name: "blackspot",
                  alias: "Pagellus bogaraveo",
                  visible: false
                },
                {
                  description: "Atlantic Wreckfish",
                  name: "wreckfish",
                  alias: "Polyprion americanus",
                  visible: false
                },
                {
                  description: "Meagre",
                  name: "meagre",
                  alias: "Argyrosomus regius",
                  visible: false
                },
                {
                  description: "Common Dentex",
                  name: "dentex",
                  alias: "Dentex dentex",
                  visible: false
                },
                {
                  description: "Gilthead Seabream",
                  name: "gilthead",
                  alias: "Sparus aurata",
                  visible: false
                },
                {
                  description: "Common Dolphinfish",
                  name: "dolphinfish",
                  alias: "Coryphaena hippurus",
                  visible: false
                },
                {
                  description: "European Seabass",
                  name: "seabass",
                  alias: "Dicentrarchus labrax",
                  visible: false
                },
                {
                  description: "Dusky Grouper",
                  name: "dusky",
                  alias: "Epinephelus marginatus",
                  visible: false
                },
                {
                  description: "Flathead Grey Mullet",
                  name: "flathead",
                  alias: "Mujil cephalus",
                  visible: false
                },
                {
                  description: "Red Porgy",
                  name: "porgy",
                  alias: "Pagrus pagrus",
                  visible: false
                },
                {
                  description: "Atlantic Salmon",
                  name: "atlan_salmon",
                  alias: "Salmo salar",
                  visible: false
                },
                {
                  description: "Greater Amberjack",
                  name: "amberjack",
                  alias: "Seriola dumerilii",
                  visible: false
                },
                {
                  description: "Rainbow Trout",
                  name: "trout_rain",
                  alias: "Oncorhynchus mykiss",
                  visible: false
                }
              ]
            },
            {
              alias: "Structural Suitability",
              name: "StructuralSuitability",
              provider: "Thredds_MSP",
              ico: "structural",
              layers: [
                {
                  alias: "Structural Suit. Index",
                  name: "structural",
                  visible: false
                }
              ]
            },
            {
              alias: "Operational Suitability",
              name: "OperationalSuitability",
              ico: "operational",
              provider: "Thredds_MSP",
              layers: [
                {
                  alias: "Operational Suit. Index",
                  name: "operational",
                  visible: false
                }
              ]
            },
            {
              alias: "Farming Opportunities",
              name: "FishFarmingOpportunities",
              ico: "opportunity",
              provider: "Thredds_MSP",
              layers: [
                {
                  description: "Atlantic Bluefin Tuna",
                  name: "bluefin_tuna",
                  alias: "Thunnus thynnus",
                  visible: false
                },
                {
                  description: "Atlantic Cod",
                  name: "cod",
                  alias: "Gadus morhua",
                  visible: false
                },
                {
                  description: "Blackspot Seabram",
                  name: "blackspot",
                  alias: "Pagellus bogaraveo",
                  visible: false
                },
                {
                  description: "Atlantic Wreckfish",
                  name: "wreckfish",
                  alias: "Polyprion americanus",
                  visible: false
                },
                {
                  description: "Meagre",
                  name: "meagre",
                  alias: "Argyrosomus regius",
                  visible: false
                },
                {
                  description: "Common Dentex",
                  name: "dentex",
                  alias: "Dentex dentex",
                  visible: false
                },
                {
                  description: "Gilthead Seabream",
                  name: "gilthead",
                  alias: "Sparus aurata",
                  visible: false
                },
                {
                  description: "Common Dolphinfish",
                  name: "dolphinfish",
                  alias: "Coryphaena hippurus",
                  visible: false
                },
                {
                  description: "European Seabass",
                  name: "seabass",
                  alias: "Dicentrarchus labrax",
                  visible: false
                },
                {
                  description: "Dusky Grouper",
                  name: "dusky",
                  alias: "Epinephelus marginatus",
                  visible: false
                },
                {
                  description: "Flathead Grey Mullet",
                  name: "flathead",
                  alias: "Mujil cephalus",
                  visible: false
                },
                {
                  description: "Red Porgy",
                  name: "porgy",
                  alias: "Pagrus pagrus",
                  visible: false
                },
                {
                  description: "Atlantic Salmon",
                  name: "atlan_salmon",
                  alias: "Salmo salar",
                  visible: false
                },
                {
                  description: "Greater Amberjack",
                  name: "amberjack",
                  alias: "Seriola dumerilii",
                  visible: false
                },
                {
                  description: "Rainbow Trout",
                  name: "trout_rain",
                  alias: "Oncorhynchus mykiss",
                  visible: false
                }
              ]
            }
          ]
        }
      ]
    },
    {
      name: "Regional/Campello",
      alias: "Campello",
      center: {
        lon: -0.39,
        lat: 38.42,
        zoom: 9
      },
      sectors: [
        {
          name: "Aquaculture",
          alias: "Aquaculture",
          types: [
            {
              alias: "Biological Suitability",
              name: "BiologicalSuitability",
              ico: "biological",
              provider: "Thredds_MSP",
              layers: [
                {
                  description: "Atlantic Bluefin Tuna",
                  name: "bluefin_tuna",
                  alias: "Thunnus thynnus",
                  visible: false
                },
                {
                  description: "Atlantic Cod",
                  name: "cod",
                  alias: "Gadus morhua",
                  visible: false
                },
                {
                  description: "Blackspot Seabram",
                  name: "blackspot",
                  alias: "Pagellus bogaraveo",
                  visible: false
                },
                {
                  description: "Atlantic Wreckfish",
                  name: "wreckfish",
                  alias: "Polyprion americanus",
                  visible: false
                },
                {
                  description: "Meagre",
                  name: "meagre",
                  alias: "Argyrosomus regius",
                  visible: false
                },
                {
                  description: "Common Dentex",
                  name: "dentex",
                  alias: "Dentex dentex",
                  visible: false
                },
                {
                  description: "Gilthead Seabream",
                  name: "gilthead",
                  alias: "Sparus aurata",
                  visible: false
                },
                {
                  description: "Common Dolphinfish",
                  name: "dolphinfish",
                  alias: "Coryphaena hippurus",
                  visible: false
                },
                {
                  description: "European Seabass",
                  name: "seabass",
                  alias: "Dicentrarchus labrax",
                  visible: false
                },
                {
                  description: "Dusky Grouper",
                  name: "dusky",
                  alias: "Epinephelus marginatus",
                  visible: false
                },
                {
                  description: "Flathead Grey Mullet",
                  name: "flathead",
                  alias: "Mujil cephalus",
                  visible: false
                },
                {
                  description: "Red Porgy",
                  name: "porgy",
                  alias: "Pagrus pagrus",
                  visible: false
                },
                {
                  description: "Atlantic Salmon",
                  name: "atlan_salmon",
                  alias: "Salmo salar",
                  visible: false
                },
                {
                  description: "Greater Amberjack",
                  name: "amberjack",
                  alias: "Seriola dumerilii",
                  visible: false
                },
                {
                  description: "Rainbow Trout",
                  name: "trout_rain",
                  alias: "Oncorhynchus mykiss",
                  visible: false
                },
                {
                  description: "Porphyra sp.",
                  name: "porphyra",
                  alias: "Porphyra sp.",
                  visible: false
                },
                {
                  description: "Codium tomentosum",
                  name: "codium",
                  alias: "Codium tomentosum",
                  visible: false
                },
                {
                  description: "Chondrus crispus",
                  name: "chondrus",
                  alias: "Chondrus crispus",
                  visible: false
                }
              ]
            },
            {
              alias: "Structural Suitability",
              name: "StructuralSuitability",
              provider: "Thredds_MSP",
              ico: "structural",
              layers: [
                {
                  alias: "Structural Suit. Index",
                  name: "structural",
                  visible: false
                }
              ]
            },
            {
              alias: "Operational Suitability",
              name: "OperationalSuitability",
              ico: "operational",
              provider: "Thredds_MSP",
              layers: [
                {
                  alias: "Operational Suit. Index",
                  name: "operational",
                  visible: false
                }
              ]
            },
            {
              alias: "Farming Opportunities",
              name: "FarmingOpportunities",
              ico: "opportunity",
              provider: "Thredds_MSP",
              layers: [
                {
                  description: "Atlantic Bluefin Tuna",
                  name: "bluefin_tuna",
                  alias: "Thunnus thynnus",
                  visible: false
                },
                {
                  description: "Atlantic Cod",
                  name: "cod",
                  alias: "Gadus morhua",
                  visible: false
                },
                {
                  description: "Blackspot Seabram",
                  name: "blackspot",
                  alias: "Pagellus bogaraveo",
                  visible: false
                },
                {
                  description: "Atlantic Wreckfish",
                  name: "wreckfish",
                  alias: "Polyprion americanus",
                  visible: false
                },
                {
                  description: "Meagre",
                  name: "meagre",
                  alias: "Argyrosomus regius",
                  visible: false
                },
                {
                  description: "Common Dentex",
                  name: "dentex",
                  alias: "Dentex dentex",
                  visible: false
                },
                {
                  description: "Gilthead Seabream",
                  name: "gilthead",
                  alias: "Sparus aurata",
                  visible: false
                },
                {
                  description: "Common Dolphinfish",
                  name: "dolphinfish",
                  alias: "Coryphaena hippurus",
                  visible: false
                },
                {
                  description: "European Seabass",
                  name: "seabass",
                  alias: "Dicentrarchus labrax",
                  visible: false
                },
                {
                  description: "Dusky Grouper",
                  name: "dusky",
                  alias: "Epinephelus marginatus",
                  visible: false
                },
                {
                  description: "Flathead Grey Mullet",
                  name: "flathead",
                  alias: "Mujil cephalus",
                  visible: false
                },
                {
                  description: "Red Porgy",
                  name: "porgy",
                  alias: "Pagrus pagrus",
                  visible: false
                },
                {
                  description: "Atlantic Salmon",
                  name: "atlan_salmon",
                  alias: "Salmo salar",
                  visible: false
                },
                {
                  description: "Greater Amberjack",
                  name: "amberjack",
                  alias: "Seriola dumerilii",
                  visible: false
                },
                {
                  description: "Rainbow Trout",
                  name: "trout_rain",
                  alias: "Oncorhynchus mykiss",
                  visible: false
                },
                {
                  description: "Porphyra sp.",
                  name: "porphyra",
                  alias: "Porphyra sp.",
                  visible: false
                },
                {
                  description: "Codium tomentosum",
                  name: "codium",
                  alias: "Codium tomentosum",
                  visible: false
                },
                {
                  description: "Chondrus crispus",
                  name: "chondrus",
                  alias: "Chondrus crispus",
                  visible: false
                }
              ]
            }
          ]
        }
      ]
    },
    {
      name: "Regional/Mediterranean",
      alias: "Mediterranean Sea",
      center: {
        lon: 15.0967822,
        lat: 38.0149379,
        zoom: 5
      },
      sectors: [
        {
          name: "Aquaculture",
          alias: "Aquaculture",
          types: [
            {
              alias: "Biological Suitability",
              name: "BiologicalSuitability",
              ico: "biological",
              provider: "Thredds_MSP",
              layers: [
                {
                  description: "Meagre",
                  name: "meagre",
                  alias: "Argyrosomus regius",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Chondrus crispus",
                  name: "chondrus",
                  alias: "Chondrus crispus",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Codium tomentosum",
                  name: "codium",
                  alias: "Codium tomentosum",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Common Dolphinfish",
                  name: "dolphinfish",
                  alias: "Coryphaena hippurus",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Common Dentex",
                  name: "dentex",
                  alias: "Dentex dentex",
                  visible: false,
                  disabled: false
                },
                {
                  description: "European Seabass",
                  name: "seabass",
                  alias: "Dicentrarchus labrax",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Dusky Grouper",
                  name: "dusky",
                  alias: "Epinephelus marginatus",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Flathead Grey Mullet",
                  name: "flathead",
                  alias: "Mujil cephalus",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Octopus vulgaris",
                  name: "octopus",
                  alias: "Octopus vulgaris",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Rainbow Trout",
                  name: "trout_rain",
                  alias: "Oncorhynchus mykiss",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Blackspot Seabram",
                  name: "blackspot",
                  alias: "Pagellus bogaraveo",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Red Porgy",
                  name: "porgy",
                  alias: "Pagrus pagrus",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Atlantic Wreckfish",
                  name: "wreckfish",
                  alias: "Polyprion americanus",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Porphyra sp.",
                  name: "porphyra",
                  alias: "Porphyra sp.",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Sepia officinalis",
                  name: "sepia",
                  alias: "Sepia officinalis",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Greater Amberjack",
                  name: "amberjack",
                  alias: "Seriola dumerilii",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Gilthead Seabream",
                  name: "gilthead",
                  alias: "Sparus aurata",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Atlantic Bluefin Tuna",
                  name: "bluefin_tuna",
                  alias: "Thunnus thynnus",
                  visible: false,
                  disabled: false
                },
              ]
            },
            {
              alias: "Structural Suitability",
              name: "StructuralSuitability",
              provider: "Thredds_MSP",
              ico: "structural",
              layers: [
                {
                  alias: "Structural Suit. Index",
                  name: "structural",
                  visible: false
                }
              ]
            },
            {
              alias: "Operational Suitability",
              name: "OperationalSuitability",
              ico: "operational",
              provider: "Thredds_MSP",
              layers: [
                {
                  alias: "Operational Suit. Index",
                  name: "operational",
                  visible: false
                }
              ]
            },
            {
              alias: "Farming Opportunities",
              name: "FarmingOpportunities",
              ico: "opportunity",
              provider: "Thredds_MSP",
              layers: [
                {
                  description: "Meagre",
                  name: "meagre",
                  alias: "Argyrosomus regius",
                  visible: false
                },
                {
                  description: "Chondrus crispus",
                  name: "chondrus",
                  alias: "Chondrus crispus",
                  visible: false
                },
                {
                  description: "Codium tomentosum",
                  name: "codium",
                  alias: "Codium tomentosum",
                  visible: false
                },
                {
                  description: "Common Dolphinfish",
                  name: "dolphinfish",
                  alias: "Coryphaena hippurus",
                  visible: false
                },
                {
                  description: "Common Dentex",
                  name: "dentex",
                  alias: "Dentex dentex",
                  visible: false
                },
                {
                  description: "European Seabass",
                  name: "seabass",
                  alias: "Dicentrarchus labrax",
                  visible: false
                },
                {
                  description: "Dusky Grouper",
                  name: "dusky",
                  alias: "Epinephelus marginatus",
                  visible: false
                },
                {
                  description: "Flathead Grey Mullet",
                  name: "flathead",
                  alias: "Mujil cephalus",
                  visible: false
                },
                {
                  description: "Octopus vulgaris",
                  name: "octopus",
                  alias: "Octopus vulgaris",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Rainbow Trout",
                  name: "trout_rain",
                  alias: "Oncorhynchus mykiss",
                  visible: false
                },
                {
                  description: "Blackspot Seabram",
                  name: "blackspot",
                  alias: "Pagellus bogaraveo",
                  visible: false
                },
                {
                  description: "Red Porgy",
                  name: "porgy",
                  alias: "Pagrus pagrus",
                  visible: false
                },
                {
                  description: "Atlantic Wreckfish",
                  name: "wreckfish",
                  alias: "Polyprion americanus",
                  visible: false
                },
                {
                  description: "Porphyra sp.",
                  name: "porphyra",
                  alias: "Porphyra sp.",
                  visible: false
                },
                {
                  description: "Sepia officinalis",
                  name: "sepia",
                  alias: "Sepia officinalis",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Greater Amberjack",
                  name: "amberjack",
                  alias: "Seriola dumerilii",
                  visible: false
                },
                {
                  description: "Gilthead Seabream",
                  name: "gilthead",
                  alias: "Sparus aurata",
                  visible: false
                },
                {
                  description: "Atlantic Bluefin Tuna",
                  name: "bluefin_tuna",
                  alias: "Thunnus thynnus",
                  visible: false
                },
              ]
            }
          ]
        },
        {
          name: "Energy",
          alias: "Marine Energy",
          types: [
            {
              alias: "Energy Resource Suit.",
              name: "EnergyResourceSuitability",
              ico: "energy",
              provider: "Thredds_MSP",
              layers: [
                {
                  alias: "Wind Resource",
                  name: "wind_resource",
                  visible: false,
                  disabled: false
                },
                {
                  alias: "Wave Resource",
                  name: "wave_resource",
                  visible: false,
                  disabled: false
                }
              ]
            },
            {
              alias: "Structural Suitability",
              name: "StructuralSuitability",
              ico: "structural",
              provider: "Thredds_MSP",
              layers: [
                {
                  alias: "Survivability (Wave Devices)",
                  name: "wave_struct",
                  visible: false,
                  disabled: false
                },
                {
                  alias: "Survivability (Wind Devices)",
                  name: "wind_struct",
                  visible: false,
                  disabled: false
                }
              ]
            },
            {
              alias: "Operational Suitability",
              name: "OperationalSuitability",
              ico: "operational",
              provider: "Thredds_MSP",
              layers: [
                {
                  alias: "Logistics (Wave)",
                  name: "wave_oper",
                  visible: false,
                  disabled: false
                },
                {
                  alias: "Logistics (Wind)",
                  name: "wind_oper",
                  visible: false,
                  disabled: false
                }
              ]
            },
            {
              alias: "Energy Transport",
              name: "EnergyTransport",
              ico: "operational",
              provider: "Thredds_MSP",
              layers: [
                {
                  alias: "Energy Transport",
                  name: "energy_transp",
                  visible: false,
                  disabled: false
                }
              ]
            },
            {
              alias: "Renewable Energy Opportunities",
              name: "RenewableEnergyOpportunities",
              ico: "opportunity",
              provider: "Thredds_MSP",
              layers: [
                {
                  alias: "Wind Energy",
                  name: "wind_energy",
                  visible: false,
                  disabled: false
                },
                {
                  alias: "Wave Energy",
                  name: "wave_energy",
                  visible: false,
                  disabled: false
                }
              ]
            }
          ]
        },
        {
          name: "Multiuse",
          alias: "Multi-use",
          types: [
            {
              alias: "Wind & Wave Opportunities",
              name: "WindWavesOpportunities",
              ico: "energy",
              provider: "Thredds_MSP",
              layers: [
                {
                  description: "Wind & Wave Energies",
                  name: "wind_wave",
                  alias: "Wind & Wave Energies",
                  visible: false,
                  disabled: false
                },
              ]
            },
            {
              alias: "Aquaculture & Wave Opportunities",
              name: "AquacultureWavesOpportunities",
              ico: "energy",
              provider: "Thredds_MSP",
              layers: [
                {
                  description: "Meagre",
                  name: "wa_meagre",
                  alias: "Argyrosomus regius",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Chondrus crispus",
                  name: "wa_chondrus",
                  alias: "Chondrus crispus",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Codium tomentosum",
                  name: "wa_codium",
                  alias: "Codium tomentosum",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Common Dolphinfish",
                  name: "wa_dolphinfis",
                  alias: "Coryphaena hippurus",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Common Dentex",
                  name: "wa_dentex",
                  alias: "Dentex dentex",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Epinephelus marginatu",
                  name: "wa_dusky",
                  alias: "Epinephelus marginatu",
                  visible: false,
                  disabled: false
                },
                {
                  description: "European Seabass",
                  name: "wa_seabass",
                  alias: "Dicentrarchus labrax",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Flathead Grey Mullet",
                  name: "wa_flathead",
                  alias: "Mujil cephalus",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Octopus vulgaris",
                  name: "wa_octopus",
                  alias: "Octopus vulgaris",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Rainbow Trout",
                  name: "wa_trout_rain",
                  alias: "Oncorhynchus mykiss",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Blackspot Seabram",
                  name: "wa_blackspot",
                  alias: "Pagellus bogaraveo",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Red Porgy",
                  name: "wa_porgy",
                  alias: "Pagrus pagrus",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Atlantic Wreckfish",
                  name: "wa_wreckfish",
                  alias: "Polyprion americanus",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Porphyra sp.",
                  name: "wa_porphyra",
                  alias: "Porphyra sp.",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Sepia officinalis",
                  name: "wa_sepia",
                  alias: "Sepia officinalis",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Greater Amberjack",
                  name: "wa_amberjack",
                  alias: "Seriola dumerilii",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Gilthead Seabream",
                  name: "wa_gilthead",
                  alias: "Sparus aurata",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Atlantic Bluefin Tuna",
                  name: "wa_bluefin_tu",
                  alias: "Thunnus thynnus",
                  visible: false,
                  disabled: false
                },
              ]
            },
            {
              alias: "Aquaculture & Wind Opportunities",
              name: "AquacultureWindOpportunities",
              ico: "energy",
              provider: "Thredds_MSP",
              layers: [
                {
                  description: "Meagre",
                  name: "wi_meagre",
                  alias: "Argyrosomus regius",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Chondrus crispus",
                  name: "wi_chondrus",
                  alias: "Chondrus crispus",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Codium tomentosum",
                  name: "wi_codium",
                  alias: "Codium tomentosum",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Common Dolphinfish",
                  name: "wi_dolphinfis",
                  alias: "Coryphaena hippurus",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Common Dentex",
                  name: "wi_dentex",
                  alias: "Dentex dentex",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Epinephelus marginatu",
                  name: "wi_dusky",
                  alias: "Epinephelus marginatu",
                  visible: false,
                  disabled: false
                },
                {
                  description: "European Seabass",
                  name: "wi_seabass",
                  alias: "Dicentrarchus labrax",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Flathead Grey Mullet",
                  name: "wi_flathead",
                  alias: "Mujil cephalus",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Octopus vulgaris",
                  name: "wi_octopus",
                  alias: "Octopus vulgaris",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Rainbow Trout",
                  name: "wi_trout_rain",
                  alias: "Oncorhynchus mykiss",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Blackspot Seabram",
                  name: "wi_blackspot",
                  alias: "Pagellus bogaraveo",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Red Porgy",
                  name: "wi_porgy",
                  alias: "Pagrus pagrus",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Atlantic Wreckfish",
                  name: "wi_wreckfish",
                  alias: "Polyprion americanus",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Porphyra sp.",
                  name: "wi_porphyra",
                  alias: "Porphyra sp.",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Sepia officinalis",
                  name: "wi_sepia",
                  alias: "Sepia officinalis",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Greater Amberjack",
                  name: "wi_amberjack",
                  alias: "Seriola dumerilii",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Gilthead Seabream",
                  name: "wi_gilthead",
                  alias: "Sparus aurata",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Atlantic Bluefin Tuna",
                  name: "wi_bluefin_tu",
                  alias: "Thunnus thynnus",
                  visible: false,
                  disabled: false
                },
              ]
            },
            {
              alias: "Aquaculture, Wind & Wave Opportunities",
              name: "AquacultureWindWavesOpportunities",
              ico: "energy",
              provider: "Thredds_MSP",
              layers: [
                {
                  description: "Meagre",
                  name: "ww_meagre",
                  alias: "Argyrosomus regius",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Chondrus crispus",
                  name: "ww_chondrus",
                  alias: "Chondrus crispus",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Codium tomentosum",
                  name: "ww_codium",
                  alias: "Codium tomentosum",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Common Dolphinfish",
                  name: "ww_dolphinfis",
                  alias: "Coryphaena hippurus",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Common Dentex",
                  name: "ww_dentex",
                  alias: "Dentex dentex",
                  visible: false,
                  disabled: false
                },
                {
                  description: "European Seabass",
                  name: "ww_seabass",
                  alias: "Dicentrarchus labrax",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Dusky Grouper",
                  name: "ww_dusky",
                  alias: "Epinephelus marginatus",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Flathead Grey Mullet",
                  name: "ww_flathead",
                  alias: "Mujil cephalus",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Octopus vulgaris",
                  name: "ww_octopus",
                  alias: "Octopus vulgaris",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Rainbow Trout",
                  name: "ww_trout_rain",
                  alias: "Oncorhynchus mykiss",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Blackspot Seabram",
                  name: "ww_blackspot",
                  alias: "Pagellus bogaraveo",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Red Porgy",
                  name: "ww_porgy",
                  alias: "Pagrus pagrus",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Atlantic Wreckfish",
                  name: "ww_wreckfish",
                  alias: "Polyprion americanus",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Porphyra sp.",
                  name: "ww_porphyra",
                  alias: "Porphyra sp.",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Sepia officinalis",
                  name: "ww_sepia",
                  alias: "Sepia officinalis",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Greater Amberjack",
                  name: "ww_amberjack",
                  alias: "Seriola dumerilii",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Gilthead Seabream",
                  name: "ww_gilthead",
                  alias: "Sparus aurata",
                  visible: false,
                  disabled: false
                },
                {
                  description: "Atlantic Bluefin Tuna",
                  name: "ww_bluefin_tu",
                  alias: "Thunnus thynnus",
                  visible: false,
                  disabled: false
                },
              ]
            },
          ]
        }
      ]
    }
  ]
};
